//#region IMPORT
import React, { useState, useEffect } from 'react';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { useBackStack } from '../../../Hooks/back/useBackStack';
import M_PPE_BASIC from './M_PPE_BASIC';
import { useSearch1, useSave1 } from './M_PPE_BASIC_Query';
import { useSave } from '../../../Hooks/useSave';
//#endregion

function M_PPE_BASICF() {
  //#region 변수
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state.BaseInfo);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const [equipList, setEquipList] = useState([]);
  //#endregion

  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTbmEnd' })),
  });

  //#region 이벤트
  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('보호구 자가 체크'));
    dispatch(NavBarInfoActions.setBgColor('#F3F7F8'));
  }, [dispatch]);
  //#endregion

  //#region 쿼리 (기존과 동일)
  useSearch1({
    onSuccess: (rows) => {
      const filtered = rows.filter((row) => {
        const departments = row.managerDepartments.split(',');
        return departments.includes(userInfo.depCd);
      });

      if (filtered.length === 0) {
        navigate('/M_AiCall');
      } else {
        setEquipList(filtered);
      }
    },
  });

  const { runAsync: Save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: 'M_PPE_BASIC',
    requestSave: (rows) => Save1Async(equipList),
    onSuccess: () => {
      navigate('/M_AiCall');
    },
  });
  //#endregion

  return (
    <div className="wrap">
      <M_PPE_BASIC
        userInfo={userInfo}
        equipList={equipList}
        setEquipList={setEquipList}
        bottomSheetState={bottomSheetState}
        SaveLogic1={Save1}
      />
    </div>
  );
}

export default M_PPE_BASICF;
